/**
 * Parses API bodies such as:
 * { success: false, message: "", data: { error: { message: "…" } } }
 */
export function extractNestedApiErrorMessage(body) {
	if (!body || typeof body !== 'object') return '';
	const nested = body?.data?.error?.message;
	if (typeof nested === 'string' && nested.trim()) return nested.trim();
	return '';
}
